import React from "react";
import moment from "moment";

const formatAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toLocaleString() : "";
};

const PetrolAmountTable = ({ data, canEdit, onEdit }) => (
  <div className="margin-y">
    <table
      width="99%"
      className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
      id="dataTables-petrolAmount"
    >
      <thead>
        <tr>
          <th>No</th>
          <th>Effective Date</th>
          <th>Amount per km (Car)</th>
          <th>Amount per km (Bike)</th>
          <th>Status</th>
          {canEdit && <th>Action</th>}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan={canEdit ? 6 : 5} className="text-center">
              No petrol amount settings found.
            </td>
          </tr>
        ) : (
          data.map((setting, index) => (
            <tr key={setting.id}>
              <td>{index + 1}</td>
              <td>
                {moment(setting.effective_date).format("YYYY-MM-DD")}
              </td>
              <td>{formatAmount(setting.amount_per_km_car)}</td>
              <td>{formatAmount(setting.amount_per_km_bike)}</td>
              <td>
                <span
                  className={
                    setting.is_active
                      ? "label label-primary"
                      : "label label-default"
                  }
                >
                  {setting.is_active ? "Active" : "Inactive"}
                </span>
              </td>
              {canEdit && (
                <td>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm own-btn-edit"
                    onClick={() => onEdit(setting)}
                  >
                    Edit
                  </button>
                </td>
              )}
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default PetrolAmountTable;
